module.exports = __webpack_public_path__ + "img/ALC072-1.e902b4bb.jpg";